import {PopupModal} from "~/modal/popup_modal";


// A little Backbone view for displaying a copy invitation warning before allowing the copy of the invitation. Setup
// the page  with an anchor tag. The anchor tag should have a proper href with the copy invitation URL. This View will
// intercept that click, stop it, and then use the HREF for forwarding if the user chooses to continue. This way we
// do not need to know the copy URL in the view nor do we have to break functionality if for some reason we have a
// browser experiencing JavaScript issues.
class CopyInvitation extends Backbone.View {

    get events() {
        return {
            'click': 'copy_invitation'
        };
    };

    copy_invitation (e) {
        e.preventDefault();
        e.stopPropagation();

        let response_callback = function(response, dialog) {
            if (response.target.innerHTML === 'Copy') {
                window.location = e.target.href;
            } else {
                dialog.close();
            }
        };
        let body = 'Are you sure you want to make a copy of this invitation? ' + 'Clicking copy will create a duplicate of this invitation and add it to your Upcoming Events.';
        let dialog = new PopupModal({
            buttons: ['Cancel', 'Copy'],
            body: body,
            title: "Copy Invitation",
            onResponse: function(response) {
                return response_callback(response, dialog);
            }
        });
        dialog.show();
    };

};


window.CopyInvitation = CopyInvitation;



// WEBPACK FOOTER //
// ./assets/es6/event/copy_invitation.es6